import axios from "./axios";

/**
 * Fetch tag definitions for a scope module (e.g. "case", "project").
 * scope_module=null returns tags available for all modules.
 */
export async function fetchTagDefinitions(scopeModule = null) {
  const params = scopeModule ? { scope_module: scopeModule } : {};
  return axios
    .get("/tag_definitions", { params })
    .then((res) => res?.data?.data ?? res?.data ?? [])
    .catch(() => []);
}

export async function createTagDefinition(payload) {
  return axios
    .post("/tag_definitions", { tag_definition: payload })
    .then((res) => res?.data?.data ?? res?.data)
    .catch((err) => err?.response?.data);
}

export async function updateTagDefinition(id, payload) {
  return axios
    .put(`/tag_definitions/${id}`, { tag_definition: payload })
    .then((res) => res?.data?.data ?? res?.data)
    .catch((err) => err?.response?.data);
}

export async function deleteTagDefinition(id) {
  return axios
    .delete(`/tag_definitions/${id}`)
    .then(() => ({ success: true }))
    .catch((err) => err?.response?.data ?? { error: true });
}
